import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { PieChart } from "lucide-react";
import { HoldingWithInstrumentAndAccount } from "@/types";

interface HoldingsDetailSectionProps {
  holdings: HoldingWithInstrumentAndAccount[];
}

export const HoldingsDetailSection: React.FC<HoldingsDetailSectionProps> = ({
  holdings,
}) => {
  const formatCurrency = (amount: number, currency: string = "USD") => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat("en-US").format(value);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <PieChart className="h-5 w-5 mr-2" />
          Holdings Detail ({holdings.length} positions)
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="border rounded-md">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Instrument</TableHead>
                <TableHead className="text-right">Quantity</TableHead>
                <TableHead className="text-right">Base Amount</TableHead>
                <TableHead>Currency</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Account</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {holdings.slice(0, 10).map((holding) => (
                <TableRow key={holding.holdingId}>
                  <TableCell>
                    <div>
                      <p className="font-medium">{holding.instrument.name}</p>
                      <p className="text-sm text-muted-foreground">{holding.instrument.instrumentKey}</p>
                    </div>
                  </TableCell>
                  <TableCell className="text-right">
                    {formatNumber(holding.quantity)}
                  </TableCell>
                  <TableCell className="text-right">
                    {formatCurrency(holding.baseAmount, holding.currency)}
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{holding.currency}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge variant={holding.isConfirmed ? "default" : "secondary"}>
                      {holding.isConfirmed ? "Confirmed" : "Unconfirmed"}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{holding.account.accountKey}</Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {holdings.length > 10 && (
            <div className="p-4 text-center text-sm text-muted-foreground border-t">
              Showing 10 of {holdings.length} holdings
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}; 